'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getMatchingJobs = require('shared/utils/match/getMatchingJobs');

var _getMatchingJobs2 = _interopRequireDefault(_getMatchingJobs);

var _objAsArray = require('shared/utils/objAsArray');

var _objAsArray2 = _interopRequireDefault(_objAsArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import arrayAsObj from 'shared/utils/arrayAsObj';

var getAllMatchingJobs = function getAllMatchingJobs(_ref, specificJobs) {
  var user = _ref.user,
      _ref$data = _ref.data,
      jobs = _ref$data.jobs,
      skills = _ref$data.skills,
      interests = _ref$data.interests,
      educationLevels = _ref$data.educationLevels;

  var correctJobs = specificJobs || jobs;
  return (0, _getMatchingJobs2.default)(correctJobs, user, {
    skills: (0, _objAsArray2.default)(skills),
    interests: (0, _objAsArray2.default)(interests),
    educationLevels: (0, _objAsArray2.default)(educationLevels)
  });
};

exports.default = getAllMatchingJobs;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/utils/getAllMatchingJobs.js
// module id = 99
// module chunks = 0